export default __webpack_public_path__ + "static/media/svg-cards.218fd87b.svg";